// import { isNil } from 'lodash';

import { addToCartCurveDelay, addToCartSped } from 'constants/general';
import { Bounty } from 'types/bounty.interface';
import { ProductInfo } from 'types/cart.interface';
import { Discount, Taxes } from 'types/order.interface';
// import { formatReward, multiply } from 'utils/currencyUtils';
import { ProductSpecificInfo } from 'types/product.interface';
import { extractNumberFromNumericFormat } from 'utils/numbers';
// import { add } from 'utils/rewardUtils';
import { isFlwr } from 'utils/productUtils';
import { getOnboardingInfo } from 'utils/storageUtils';

export const calculateTotalQuantity = (products?: { [key: string]: ProductInfo }): number => {
  if (!products || !Object.keys(products)) {
    return 0;
  }

  return Object.values(products).reduce((acc: number, item: ProductInfo) => {
    acc += (item?.weight || isFlwr(item?.sortUnit))
      ? 1
      : Math.max(0, Math.ceil(item.quantity));
    return acc;
  }, 0);
};

export const formatProductForCart = (
  bounty: Bounty,
  quantity: number,
  productVariant: ProductSpecificInfo | null,
  weight?: string | null,
  kioskMode?: boolean,
): ProductInfo => {
  const { product } = bounty;
  const { merchant } = product || {};

  return {
    id: `temp:${bounty?.id}`,
    bountyId: bounty?.id,
    merchant,
    merchantId: merchant?.id,
    productSku: productVariant?.sku || product?.merchantSku,
    name: product?.name,
    description: product?.description,
    imageUrl: product?.imageUrl,
    price: productVariant?.price?.mainPrice,
    msrp: productVariant?.msrp,
    addedAt: new Date().getTime(),
    availableQuantity: productVariant?.quantity || 0,
    maxAllowedQty: productVariant?.maxAllowedQty,
    imageCdn: product?.imageCdn,
    manufacturer: productVariant?.manufacturer || '',
    quantity: Math.max(0, quantity || 0),
    weight: weight
      ? extractNumberFromNumericFormat({ value: weight, hasSuffix: kioskMode })?.toString()
      : null,
    sortWeight: productVariant?.sortWeight,
    sortUnit: productVariant?.sortUnit,
    weightUnit: productVariant?.weightUnit,
    altPrices: product?.altPrices,
  };
};

// export function getCartTotal(products: ProductInfo[]) {
//   let total: object | null = {};
//
//   Object.values(products).forEach(({ price, quantity, weight }) => {
//     const qty = isNil(weight) ? Math.max(0, quantity || 0) : 1;
//
//     if (price) {
//       total = total
//         ? add(total, multiply(price, qty))
//         : multiply(price, qty);
//     }
//   });
//
//   return total;
// }

// export function calculateCartTotal(products: ProductInfo[]) {
//   const total = getCartTotal(products);
//
//   return formatReward(total, '0');
// }

export function getDiscountsTotal(discounts: Discount[]) {
  let discountsTotal = 0;
  let discountCurrency = '';

  discounts?.forEach((discount: Discount) => {
    const discountAmount = discount?.amount?.money?.amount;
    discountsTotal += discountAmount ? +discountAmount : 0;
    discountCurrency = discount?.amount?.money?.currency;
  });

  return { discountsTotal, discountCurrency };
}

export function getTaxesTotal(taxes: Taxes[]) {
  let taxesTotal = 0;
  let taxesCurrency = '';

  taxes?.forEach((tax: Taxes) => {
    const amount = tax?.amount?.amount || 0;
    taxesTotal += +amount;
    taxesCurrency = tax?.amount?.currency;
  });

  return { taxesTotal, taxesCurrency };
}

export function formatSummaryProducts(products: ProductInfo[]) {
  return products?.reduce((acc: { [key: string]: ProductInfo }, item: ProductInfo) => ({
    [item.id]: item,
  }), {});
}

export function getStoreCartKey(): string {
  const { useType, storeId } = getOnboardingInfo() || {};

  if (storeId && useType) {
    return `${storeId}_${useType}`;
  }

  if (storeId) {
    return storeId;
  }

  return 'default';
}

export function generateUID() {
  return Date.now().toString(36);
}

export const getCartPriceValue = (
  { value, isLoading, hasFailed }: { value: string; isLoading?: boolean; hasFailed?: boolean},
) => {
  if (isLoading) {
    return 'Calculating...';
  }

  if (hasFailed) {
    return 'N/A';
  }

  return value;
};

export const addItemFlyImage = (
  mainPictureUrl: string,
  onCancel: () => void,
) => {
  const productImage = document.querySelector('#product-cover');
  const cart = document.querySelector('#shopping-cart');

  if (!productImage || !cart) {
    return;
  }

  const { top: startY, left: startX } = productImage.getBoundingClientRect();
  const { top: endY, left: endX } = cart.getBoundingClientRect();

  const flyingImage = document.createElement('img');
  flyingImage.src = mainPictureUrl;
  flyingImage.style.position = 'fixed';
  flyingImage.style.top = `${startY}px`;
  flyingImage.style.left = `${startX}px`;
  flyingImage.style.borderRadius = '12px';
  flyingImage.style.zIndex = '1301';
  flyingImage.style.opacity = '1';
  flyingImage.style.height = '150px';
  flyingImage.style.width = '150px';
  flyingImage.style.pointerEvents = 'none';

  document.body.appendChild(flyingImage);

  const duration = addToCartSped + addToCartCurveDelay;
  const peakOffsetY = -150;
  const controlPointX = (startX + endX) / 2 + 100;

  const startTime = performance.now();

  const animate = (time: number) => {
    const elapsed = time - startTime;
    const t = Math.min(elapsed / duration, 1);

    const currentX = (1 - t) * (1 - t) * startX + 2 * (1 - t) * t * controlPointX + t * t * endX;
    const currentY = (1 - t) * (1 - t) * startY + 2 * (1 - t) * t * (startY + peakOffsetY) + t * t * endY;

    flyingImage.style.left = `${currentX}px`;
    flyingImage.style.top = `${currentY}px`;

    const scale = 1 - 0.5 * t;
    flyingImage.style.transform = `scale(${scale})`;

    if (t < 1) {
      requestAnimationFrame(animate);
    } else {
      flyingImage.remove();
      onCancel();
    }
  };

  requestAnimationFrame(animate);
};
